export enum ProvisionCategoryCodes {
  DOMAINS = "domain-names",
  SHARED_HOSTING = "shared-hosting"
}

export enum RegistrarTypes {
  MANUAL = "manual"
}
